import { Button, Row } from 'antd';
import styled from 'styled-components';

export const BlocoPar = styled(Row)`
    background: #fff;
    border-radius: 0;
    padding: 20px;
    .anticon.anticon-calendar{
        color:#24A95D;
    }
    .ant-picker.ant-picker-range{
        background: #F2F2F2;
        border:none;
    }
    .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-start-single > div{
        border: 1px solid #24A95D;
        background: #24A95D;

    }
    .ant-picker-cell-in-view.ant-picker-cell-range-start::before {
        background: #24A95D;
    }

`;
export const Text = styled.p`
    font-weight: bold;
    font-size: 24px;
    line-height: 37px;
    color: #001F2A;
    margin:0;
    min-width: 280px;
    text-align: start;
`;

export const TextTitle = styled.p`
    font-weight: bold;
    font-size: 32px;
    line-height: 37px;
    color: #001F2A;
    margin:0;
    min-width: 370px;
    text-align: start;
`;
export const StyledButtonCancel = styled(Button)`
  width: 116px;
  height: 40px;
  color: #24a95d !important;
  border-radius: 0;
  background: #fff !important;
  border: solid 1px #24a95d;
  outline: none;
  font-weight: bold;
  margin: 0 5px;
  outline:none;
  &:hover {
    background: #fff !important;
    color: #24a95d;
    transform: scale(1.05);
    border: solid 1px #24a95d;
  }
  &:focus {
    background: #fff !important;
    color: #24a95d;
    border: solid 1px #24a95d;
  }
`;

export const StyledButton = styled(Button)`
  width: 116px;
  height: 40px;
  color: #fff;
  border-radius: 0;
  background: #24a95d !important;
  border: none;
  outline: none;
  font-weight: bold;
  margin: 0 5px;

  &:hover {
    background: #24a95d;
    color: #fff;
    transform: scale(1.05);
  }
  &:focus {
    background: #24a95d;
    color: #fff;
  }
`;
